module.exports = __webpack_public_path__ + "static/present-b3bf52ee00f5100bc91715aecc07029d.svg";